import { Router } from '@angular/router';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public currentUserSubject: BehaviorSubject<User>;
  public tokenSubject: BehaviorSubject<string>;
  public currentUser: Observable<User>;
  public httpOptions: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private cookieService: CookieService
  ) {
      this.currentUserSubject = new BehaviorSubject<User>(new User());
      this.currentUser = this.currentUserSubject.asObservable();
      //this.tokenSubject = new BehaviorSubject<string>(localStorage.getItem('token'));
      this.tokenSubject = new BehaviorSubject<string>(this.cookieService.get('token'));
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public get tokenValue(): string {
    return this.tokenSubject.value;
  }

  login(email: string, password: string, voucher: string) {
    return this.http.post<any>(`${environment.apiUrl}/login`, {
        email: `${email}`,
        password: `${password}`,
        voucher: `${voucher}`,
      })
      .pipe(map(response => {
        if (response && response.success) {
          this.setUserData(response.data.user);
        }
        this.setNewToken(response.token);
        return response;
      }));
  }

  logout() {
    this.removeTokenAndUserDetails();
    this.router.navigate(['/sign-in']);
  }

  removeTokenAndUserDetails() {
    //localStorage.removeItem('token');
    this.cookieService.delete('token');
    this.tokenSubject.next(null);
    this.currentUserSubject.next(null);
  }

  register(firstName: string, lastName: string, email: string, password: string, voucher: string) {
    return this.http.post<any>(`${environment.apiUrl}/register`, {
        first_name: `${firstName}`,
        last_name: `${lastName}`,
        email: `${email}`,
        password: `${password}`,
        voucher: `${voucher}`
      })
      .pipe(map(response => {
        return response;
      }));
  }

  activateAccount(email: string, token: string) {
    return this.http.post<any>(`${environment.apiUrl}/activate`, {
        email: `${email}`,
        token: `${token}`,
      })
      .pipe(map(response => {
        return response;
      }));
  }

  resendActivationLink(email: string) {
    return this.http.post<any>(`${environment.apiUrl}/resend_activation`, {
        email: `${email}`,
      })
      .pipe(map(response => {
        return response;
      }));
  }

  setNewToken(token: string) {
    //localStorage.setItem('token', token);
    this.cookieService.set('token', token);
    this.tokenSubject.next(token);
  }

  setUserData(data: any) {
    const userData: User = {
      firstName: data.first_name,
      lastName: data.last_name,
      fullName: data.first_name + ' ' + data.last_name,
      email: data.email,
      avatar: data.avatar,
      role: data.role,
      isSubscribed: data.is_subscribed,
      points: data.points_earned,
    };
    this.currentUserSubject.next(userData);
  }

  forgotPassword(email: string) {
    return this.http.post<any>(`${environment.apiUrl}/reset_password`, {
      email: `${email}`
    })
    .pipe(map(response => {
      if (response && response.token) {
        console.log(response);
      }
      return response;
    }));
  }

  newPassword(token: string, password: string) {
    return this.http.post<any>(`${environment.apiUrl}/reset_password_save`, {
      token: `${token}`,
      new_password: `${password}`
    })
    .pipe(map(response => {
      if (response && response.token) {
        console.log(response);
      }
      return response;
    }));
  }

  getTokenDetails(token: string) {
    return this.http.post<any>(`${environment.apiUrl}/token-details`, {token: `${token}`})
      .pipe(map(response => {
        return response;
      }));
  }

}
